import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { persistor, store } from './store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from 'react-hot-toast';
import { CookiesProvider } from 'react-cookie';
import './App.scss'
import { ConfigProvider, Empty } from 'antd';
import SessionManager from './components/sessionManager/SessionManager';

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppRoutes = () => {
  return useRoutes(App)
}
const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim()
root.render(
  <CookiesProvider>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ConfigProvider 
          renderEmpty={() => <Empty description="No Record Found" image={Empty.PRESENTED_IMAGE_SIMPLE} />} 
          theme={{ token: {fontFamily:"Public Sans",colorPrimary: primaryColor } }}
        >
          <BrowserRouter>
            <Toaster
              position="top-right"
              reverseOrder={false}
              toastOptions={{duration:4000}}
            />
            <SessionManager/>
            <AppRoutes />
          </BrowserRouter>
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </CookiesProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
